export enum IssueTimelineItemType {
	CREATED = "created",
	ISSUE_COMMENT = "issue_comment",
	ISSUE_UPDATE = "issue_update",
	ISSUE_ATTACHMENT = "issue_attachment",
	ISSUE_ASSOCIATION = "issue_association",
	FIELD_VALUES = "field_values",
	IDENTIFIER_VALUE = "identifier_value",
	FORM_SUBMISSION = "form_submission",
}
